import { fetchCustomersSchema, fetchCustomers } from '../api/customers';

const state = {
    schema: {},
    customers: [],
};

const getters = {
    customersById: (state) => state.customers.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {}),
};

const mutations = {
    SET_CUSTOMERS_SCHEMA(state, schema = {}) {
        state.schema = Object.freeze(schema);
    },
    SET_CUSTOMERS(state, { results }) {
        state.customers = Object.freeze(results);
    },
};

const actions = {
    async fetchCustomersSchema({ commit }) {
        commit('SET_CUSTOMERS_SCHEMA', await fetchCustomersSchema());
    },
    async fetchCustomers({ commit }) {
        commit('SET_CUSTOMERS', await fetchCustomers());
    },
    async fetchData({ dispatch }) {
        await Promise.all([dispatch('fetchCustomersSchema'), dispatch('fetchCustomers')]);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
